<template>
    <v-container fluid>
        <v-row
            class="mx-0"            
        >
            <v-col
                class="title mt-2"
                cols="8"
            >
                Locator LOGiX EOD
            </v-col>
        </v-row>
        <v-row
            class="mx-0"            
        >
            <v-col
                cols="12"
                lg="10"
                md="9"
                sm="8"
                xs="12"
                class="company"
            >
                <template v-if="reportMonthandYear">
                    {{ companyName }} EOD Reports for {{ getLabel() }}<v-chip
                        class="mx-1"
                        outlined
                        pill
                        small
                    >
                        {{ count }}
                    </v-chip>
                </template>
                <template v-else>
                    {{ companyName }} EOD Reports
                </template>
            </v-col>

            <v-col
                cols="12"
                lg="2"
                md="3"
                sm="4"
                xs="12"
            >
                <v-select
                    v-model="reportMonthandYear"
                    :items="companyStatsCompanyEOD"
                    :item-text="'label'"
                    :item-value="'value'"
                    label="Month"
                    outlined
                    dense
                    @change="getCompanyCompanyEODList"
                />
            </v-col>
        </v-row>
        <v-row
            dense
            class="mx-0"
        >
            <v-col>
                <v-data-table
                    id="companyEodListTable"
                    :headers="headers"
                    :items="CompanyCompanyEODList"
                    :items-per-page="itemsPerPage"
                    style="white-space: nowrap;"
                    :loading="loading"
                    loading-text="Loading... Please wait"
                    @update:items-per-page="saveItemPerPage"
                >
                    <template v-slot:[`item.eod_date`]="{item}">
                        {{ formatDate(item.eod_date) }}
                    </template>                   
                    <template v-slot:[`item.download`]="{item}">
                        <v-btn
                            icon
                            @click="downloadBtnClick(item)"
                        >
                            <v-icon>mdi-tray-arrow-down</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:[`item.view`]="{item}">
                        <v-btn
                            icon
                            @click="viewBtnClick(item)"
                        >
                            <v-icon>mdi-eye-outline</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog
            v-model="dialog"
            width="90%"
            :fullscreen="this.$vuetify.breakpoint.xsOnly"
            persistent
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2">
                    <v-icon
                        color="primary"
                        class="material-icons-outlined"
                    >
                        mdi-eye-outline
                    </v-icon>
                    <span>{{ reportName }}</span>
                    <v-spacer />
                    <v-btn
                        style="text-transform: none !important"
                        depressed
                        @click="dialogCancel"
                    >
                        X
                    </v-btn>
                </v-card-title>
                <v-divider />
                <div
                    class="report-container"
                >
                    <pre>{{ reportText }}</pre>
                </div>
               
                <div :class="{'mobile-download-buttons': !this.$vuetify.breakpoint.smAndUp }">
                    <v-divider />
                    <v-card-actions>
                        <v-spacer v-if="this.$vuetify.breakpoint.smAndUp" />
                        <v-btn
                            style="text-transform: none !important;margin-right: 5px;"
                            depressed
                            color="primary"
                            @click="dialogCancel"
                        >
                            Close
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
export default {   
    data: () => ({
        headers: [
            {text: 'Date', value: 'eod_date', width: '10%' },
            {text: 'Name', value: 'name', align: 'left', sortable: false},
            {text: 'Download', value: 'download', align: 'center',sortable: false, width: '5%' },
            {text: 'View', value: 'view', align: 'center',sortable: false, width: '5%' }
        ],
        reportMonthandYear: '',
        companyStatsCompanyEOD:[],
        CompanyCompanyEODList:[],
        showViewEodReportDialog: false,
        reportName: '',
        reportText: '',
        count: 0,
        loading: false,
        dialog: false,
    }),
    computed: {
        companyName() {
            return this.$store.getters.company.company;
        },
        itemsPerPage() {            
            return this.$store.getters.itemsPerPage <= 15 ? this.$store.getters.itemsPerPage : 10;
        },
    },
    async mounted() {
        // populate Eod Month with the months and counts; select the first item
        let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
       
        const data = await webtmsBackend.getCompanyStatsCompanyEOD();
       
        for(let m of data.companyStatsEODReports) {
            let monthYear = m.month;
            let count = m.count;
            this.count = count;
            let label = months[Number(monthYear.substring(5)) - 1] + ', ' + monthYear.substring(0, 4);
            if(monthYear){
                this.companyStatsCompanyEOD.push({
                    value: monthYear,
                    month: monthYear.substring(5),
                    year: monthYear.substring(0, 4),
                    label: label,
                    count: count
                });
            }
        }
        let currentDate = new Date();
        let currentMonth = currentDate.toLocaleString('en-US', { month: '2-digit' });
        let currentYear = currentDate.getFullYear(); 
      
        this.reportMonthandYear = currentYear + '-' + currentMonth;
        this.getCompanyCompanyEODList();       
    },
    methods: {
        async getCompanyCompanyEODList() {
            this.loading = true;
            try{            
                this.CompanyCompanyEODList = [];               
                let response = await webtmsBackend.getCompanyCompanyEODList(this.reportMonthandYear);
                this.loading = false;
                for(let list of response.data){
                    list.name = this.formatReportName(list.report_text);
                    this.CompanyCompanyEODList.push(list);
                }
            } catch(error) {
                console.error('getCompanyCompanyEODList error ', error);
                this.loading = false;
            }
        
        },
        getLabel(){
            for(let m of this.companyStatsCompanyEOD) {
                if(m.value == this.reportMonthandYear) {
                    this.count = m.count;
                    return m.label;
                }
            }
        },
        downloadBtnClick(item) {
            this.reportText = item.report_text;
            let reportName = this.reportText.split('<pre>')[1].split('(')[0].replace(/^\s+|\s+$/g, '');
            let a = document.createElement('a');
            if (typeof a.download !== 'undefined') a.download = reportName;
            a.href = URL.createObjectURL(new Blob([item.report_text], {
                type: 'text/html'
            }));
            a.dispatchEvent(new MouseEvent('click'));
            a.remove();
        },
        viewBtnClick(item) {
            this.reportText = item.report_text.split('<pre>')[1].split('</pre>')[0];
            this.reportName = this.formatReportName(item.report_text);
            this.dialog = true;
        },
        formatReportName(report_text) {
            let reportName = 'LOCATOR LOGiX EOD';
            let reportDate = report_text.split('<pre>')[1].split('(')[1].split(')')[0];
            return reportName +' for ' + reportDate;
        },
        dialogCancel(){
            // Close dialog on partent component
            this.dialog = false;
        },
        getEodReport() {
            this.reportName = this.reportText.split('<pre>')[1].split('(')[0];
            this.$refs.report.innerHTML = this.reportText;
        },
        formatDate(date) {
            let month = date.split('-')[1];
            let day = date.split('-')[2];
            let year = date.split('-')[0];
            return month + '/' + day + '/' + year;
        },
        saveItemPerPage(val) {
            this.$store.dispatch('setItemsPerPage', val);           
        },
    },
}
;
</script>
<style>
    #companyEodListTable thead,
    #companyEodListTable th {
        background-color: var(--ll-surface-subtle);
    }
    #companyEodListTable td {
        background: var(--ll-surface);
    }
    .title {
        font-size: 20px;
    }
    .company {
        font-size: 16px;
        font-weight: 500;
    }   
</style>
